import {
    CLEAR_FORM_FIELDS_LIST,
    SET_FORM_FIELDS_LIST,
    FORM_FIELDS_LIST_ERROR,
    FORM_FIELDS_LIST_ERROR_CLEAR,
    FORM_FIELDS_LIST_PENDING,
    FIELD_DELETE_CONFIRMATION_OPEN,
    FIELD_DELETE_CONFIRMATION_CLOSE,
    FORM_FIELDS_UPDATE_PENDING,
    FORM_FIELDS_UPDATE_ERROR,
    FORM_FIELDS_UPDATE_ERROR_CLEAR,
    FORM_FIELD_DELETE_PENDING,
    FORM_FIELD_DELETE_ERROR,
    FORM_FIELD_DELETE_ERROR_CLEAR,
    FORMULA_CREATE_DIALOG_CLOSE,
    FORMULA_CREATE_DIALOG_OPEN,
    FORMULA_EDIT_DIALOG_OPEN,
    FORMULA_EDIT_DIALOG_CLOSE,
    SELECTED_FORMULA_FIELD_FOR_EDIT,
    SELECTED_FORMULA_FIELD_FOR_CREATE,
    SET_SELECTED_FORM_FIELD_INDEX,
} from "./constants"


const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    formFieldsList: null,
    formFieldsListCount: 0,
    isFormFieldsListPending: false,
    formFieldsListErrorMessage: null,
    //-----------------------------|| UPDATE ||---------------------------------------------------------------
    selectedFormFieldIndex: null,
    isFormFieldsUpdatePending: false,
    formFieldsUpdateErrorMessage: null,
    //-----------------------------|| DELETE ||-------------------------------------------------------------
    fieldDeleteConfirmationDialogOpen: false,
    isFormFieldDeletePending: false,
    formFieldDeleteErrorMessage: null,
    //-----------------------------|| FORMULA CREATE DIALOG ||-------------------------------------------------------------
    formulaCreateDialogOpen: false,
    formulaCreateData: null,
    //-----------------------------|| FORMULA EDIT DIALOG ||-------------------------------------------------------------
    formulaEditDialogOpen: false,
    formulaEditData: null,
}

const formConfiguration = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case FORM_FIELDS_LIST_PENDING: {
            return {
                ...state,
                isFormFieldsListPending: true,
                formFieldsListErrorMessage: null,
            }
        }

        case SET_FORM_FIELDS_LIST: {
            const { duplicateOrderRemovedList, formFieldsList } = action.payload || {};
            return {
                ...state,
                formFieldsList: duplicateOrderRemovedList,
                formFieldsListCount: formFieldsList['@odata.count'],
                isFormFieldsListPending: false,
                formFieldsListErrorMessage: null,
            }
        }

        case FORM_FIELDS_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formFieldsListErrorMessage: errorMessage,
                isFormFieldsListPending: false,
                formFieldsList: null,
                formFieldsListCount: 0,
            }
        }

        case FORM_FIELDS_LIST_ERROR_CLEAR: {
            return {
                ...state,
                formFieldsListErrorMessage: null,
                isFormFieldsListPending: false,
            }
        }

        case CLEAR_FORM_FIELDS_LIST: {
            return {
                ...state,
                formFieldsList: null,
                formFieldsListCount: 0,
            }
        }

        //-----------------------------|| UPDATE ||---------------------------------------------------------------
        case SET_SELECTED_FORM_FIELD_INDEX: {
            const { index } = action.payload || {};
            return {
                ...state,
                selectedFormFieldIndex: index
            }
        }
        case FORM_FIELDS_UPDATE_PENDING: {
            return {
                ...state,
                isFormFieldsUpdatePending: true,
                formFieldsUpdateErrorMessage: null,
            }
        }

        case FORM_FIELDS_UPDATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formFieldsUpdateErrorMessage: errorMessage,
                isFormFieldsUpdatePending: false,
            }
        }

        case FORM_FIELDS_UPDATE_ERROR_CLEAR: {
            return {
                ...state,
                formFieldsUpdateErrorMessage: null,
                isFormFieldsUpdatePending: false,
            }
        }

        //-----------------------------|| DELETE ||-------------------------------------------------------------
        case FIELD_DELETE_CONFIRMATION_OPEN: {
            return {
                ...state,
                fieldDeleteConfirmationDialogOpen: true,
            }
        }

        case FIELD_DELETE_CONFIRMATION_CLOSE: {
            return {
                ...state,
                fieldDeleteConfirmationDialogOpen: false,
            }
        }

        case FORM_FIELD_DELETE_PENDING: {
            return {
                ...state,
                isFormFieldDeletePending: true,
                formFieldDeleteErrorMessage: null,
            }
        }

        case FORM_FIELD_DELETE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formFieldDeleteErrorMessage: errorMessage,
                isFormFieldDeletePending: false,
            }
        }

        case FORM_FIELD_DELETE_ERROR_CLEAR: {
            return {
                ...state,
                formFieldDeleteErrorMessage: null,
                isFormFieldDeletePending: false,
            }
        }

        //-----------------------------|| FORMULA DIALOG ||-------------------------------------------------------------
        case FORMULA_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                formulaCreateDialogOpen: true,
            }
        }

        case FORMULA_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                formulaCreateDialogOpen: false,
            }
        }

        case SELECTED_FORMULA_FIELD_FOR_CREATE: {
            const { selectedData } = action.payload || {};
            return {
                ...state,
                formulaCreateData: selectedData,
            }
        }

        //-----------------------------|| FORMULA EDIT DIALOG ||-------------------------------------------------------------
        case FORMULA_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                formulaEditDialogOpen: true,
            }
        }

        case FORMULA_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                formulaEditDialogOpen: false,
            }
        }

        case SELECTED_FORMULA_FIELD_FOR_EDIT: {
            const { selectedData } = action.payload || {};
            return {
                ...state,
                formulaEditData: selectedData,
            }
        }

        default: {
            return state;
        }
    }
}

export default formConfiguration;